var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star",
    clipPath: "url(#clip0_6956_75457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Star 1",
    d: "M16.9094 2.37585C16.9453 2.29893 17.0547 2.29893 17.0906 2.37585L21.1136 10.9916C21.269 11.3244 21.5802 11.5577 21.9433 11.6135L30.9917 13.0032C31.0719 13.0155 31.1048 13.1134 31.0482 13.1717L24.4597 19.9597C24.2174 20.2093 24.1075 20.5588 24.1632 20.9021L25.7128 30.4513C25.7261 30.5338 25.6385 30.5953 25.5655 30.5547L17.5343 26.092C17.202 25.9073 16.798 25.9073 16.4657 26.092L8.43452 30.5547C8.3615 30.5953 8.27386 30.5338 8.28724 30.4513L9.8368 20.9021C9.89251 20.5587 9.78257 20.2093 9.54033 19.9597L2.95177 13.1717C2.89519 13.1134 2.92805 13.0155 3.00835 13.0032L12.0567 11.6135C12.4198 11.5577 12.731 11.3244 12.8864 10.9916L16.9094 2.37585Z",
    fill: "current",
    fillOpacity: "current",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6956_75457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.6fa9d62b4c768d0a4591eaf07cfc4d52.svg";
export { ForwardRef as ReactComponent };